import { AnimatePresence, motion} from 'framer-motion'

//css
import './css/skills.css'
import './css/skill1.css'


const Skill1 = ({skillCounter,animatinDir }) => {
	return(
				<motion.div 
					initial={animatinDir==="right"?{opacity:0,left:"100%"}:{opacity:0,left:"-100%"}}
					animate={{opacity:1, left:"50%"}}
					transition={{duration:1}}
					exit={{opacity:0}}
					className="skill" 
					id="skill1">
						<div className="skill_head">
							<p>Backend</p>
						</div>
						<div className="skill_body" id="skill_1_body">	
							<div>						
								<div className="skill_1_body_content">
									<div>
										<p style={{color: "#29C133", padding:"5px 0",fontWeight:"bold", fontSize: "14px"}}>
											Build your backend with Node.js & Express
										</p>
										<p style={{color: "#8A8EA2", lineHeight: "22x"}}>
											i am totaly into building backends for websites using Node.js technology, on
										</p>
										<p style={{color: "#8A8EA2", lineHeight: "25px", marginTop:"10px"}}>
											GraphQL, SocketIO, Axios
										</p>
									</div>									

									<div>
										<p>Node.JS</p>
										<p>Express Framework</p>
										<p>GraphQL</p>
										<p>Socket.io</p>
										<p>Axios</p>
									</div>
								</div>
								<i className="fab fa-node-js" id="node_i"></i>
							</div>
							
							<div className="skill_footer">
								<i className="fas fa-info-circle"></i>Express framework makes backend development
							</div>

						</div>
				</motion.div>
		)
}

export default Skill1